import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useMediaQuery, useTheme } from "@mui/material";
import axiosInstanceMainUrl from "../../utils/axiosInstanceMainUrl";

const CompleteForm = ({ setShowForm }) => {
  
  const mainUrl = import.meta.env.VITE_MAIN_URL;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    dob: "",
    mobileNo: "",
    password: "",
    confirmPassword: "",
    Address: "",
    state: "",
    city: "",
    pincode: "",
    aadharNo: "",
    panNo: "",
    accHoldername: "",
    accNo: "",
    confirmaccNo: "",
    Ifsccode: "",
    registerType: "individual",
  });

  const [validated, setValidated] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [states, setStates] = useState([]);
  const [stateId, setstateId] = useState("");

  const [cities, setCities] = useState([]);
  const [showMessage, setshowMessage] = useState("");

  // Fetch states
  useEffect(() => {
    const url = `/augmontGold/states`;
    // const url = `${mainUrl}/augmontGold/states`;

    axiosInstanceMainUrl
      .get(url)
      .then((response) => setStates(response.data.data))
      .catch((error) => console.error("Error fetching states:", error));
  }, []);

  // Fetch cities based on selected state
  useEffect(() => {
    if (stateId) {
      const url = `/augmontGold/city/${stateId}`;
      // const url = `${mainUrl}/augmontGold/city/${stateId}`;
      axiosInstanceMainUrl
        .get(url)
        .then((response) => setCities(response.data.data))
        .catch((error) => console.error("Error fetching cities:", error));
      // axios
      //   .get(url)
      //   .then((response) => setCities(response.data.data))
      //   .catch((error) => console.error("Error fetching cities:", error));
    }
  }, [stateId]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleStateChange = (event, value) => {
    setFormData({
      ...formData,
      state: value ? value.name : "",
      city: "", // Reset city when state changes
    });
    setstateId(value.id);
    setCities([]); // Clear cities until new data is fetched
  };

  const handleCityChange = (event, value) => {
    setFormData({
      ...formData,
      city: value ? value.name : "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      finalSubmit();
    } else {
      setValidated(true);
    }
  };
  const finalSubmit = async () => {
    try {
      const url = `/partner_registeration`;
      // const url = `${mainUrl}/partner_registeration`;

      const response = await axiosInstanceMainUrl.post(url, formData);
      setshowMessage(response?.data?.message);
      if (response.data.message == "Partner registered successfully") {
        toast.success("Partner registered successfully");

        setShowForm(true)
        setFormData({
          name: "",
          email: "",
          dob: "",
          mobileNo: "",
          password: "",
          confirmPassword: "",
          Address: "",
          state: "",
          city: "",
          pincode: "",
          aadharNo: "",
          panNo: "",
          accHoldername: "",
          accNo: "",
          confirmaccNo: "",
          Ifsccode: "",
        });
        setValidated(false);
        setTermsAccepted(false);
        setstateId("");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };
  const validateForm = () => {
    const passwordMatch = formData.password === formData.confirmPassword;
    const accountNoMatch = formData.accNo === formData.confirmaccNo;
    return (
      passwordMatch &&
      accountNoMatch &&
      termsAccepted &&
      Object.values(formData).every((field) => field)
    );
  };

   const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check
    

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Grid container spacing={3} padding={isMobile?0:3}>
        <Grid item xs={12}>
          <Typography variant="h5">Register as Individual Partner</Typography>
        </Grid>

        {/* Part 1 Fields */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.name}
            helperText={validated && !formData.name ? "Name is required." : ""}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.email}
            helperText={
              validated && !formData.email ? "Valid email is required." : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="DOB"
            name="dob"
            type="date"
            value={formData.dob}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            fullWidth
            error={validated && !formData.dob}
            helperText={validated && !formData.dob ? "DOB is required." : ""}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Phone no."
            name="mobileNo"
            type="text"
            value={formData.mobileNo}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.mobileNo}
            helperText={
              validated && !formData.mobileNo
                ? "Valid 10-digit phone number is required."
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.password}
            helperText={
              validated && !formData.password
                ? "Password of at least 6 characters is required."
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            fullWidth
            error={validated && formData.password !== formData.confirmPassword}
            helperText={
              validated && formData.password !== formData.confirmPassword
                ? "Passwords do not match."
                : ""
            }
          />
        </Grid>

        {/* Part 2 Fields */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Address"
            name="Address"
            value={formData.Address}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.Address}
            helperText={
              validated && !formData.Address ? "Address is required." : ""
            }
          />
        </Grid>
        {/* State Selection */}
        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={states}
            getOptionLabel={(option) => option?.name}
            onChange={handleStateChange}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label="State"
                name="state"
                required
                error={validated && !formData?.state}
                helperText={
                  validated && !formData?.state ? "State is required." : ""
                }
              />
            )}
          />
        </Grid>
        {/* City Selection */}
        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={cities}
            getOptionLabel={(option) => option?.name}
            onChange={handleCityChange}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label="City"
                name="city"
                required
                error={validated && !formData.city}
                helperText={
                  validated && !formData.city ? "City is required." : ""
                }
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Pincode"
            name="pincode"
            type="text"
            value={formData.pincode}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.pincode}
            helperText={
              validated && !formData.pincode ? "Pincode is required." : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Aadhar No."
            name="aadharNo"
            type="text"
            value={formData.aadharNo}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.aadharNo}
            helperText={
              validated && !formData.aadharNo ? "Aadhar no. is required." : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="PAN No."
            name="panNo"
            type="text"
            value={formData.panNo}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.panNo}
            helperText={
              validated && !formData.panNo ? "PAN no. is required." : ""
            }
          />
        </Grid>

        {/* Part 3 Fields */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Account Holder's Name"
            name="accHoldername"
            value={formData.accHoldername}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.accHoldername}
            helperText={
              validated && !formData.accHoldername
                ? "Account holder's name is required."
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Account No."
            name="accNo"
            type="text"
            value={formData.accNo}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.accNo}
            helperText={
              validated && !formData.accNo ? "Account no. is required." : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Confirm Account No."
            name="confirmaccNo"
            type="text"
            value={formData.confirmaccNo}
            onChange={handleChange}
            required
            fullWidth
            error={validated && formData.accNo !== formData.confirmaccNo}
            helperText={
              validated && formData.accNo !== formData.confirmaccNo
                ? "Account numbers do not match."
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="IFSC Code"
            name="Ifsccode"
            type="text"
            value={formData.Ifsccode}
            onChange={handleChange}
            required
            fullWidth
            error={validated && !formData.Ifsccode}
            helperText={
              validated && !formData.Ifsccode ? "IFSC code is required." : ""
            }
          />
        </Grid>

        {/* Terms and Submit */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
              />
            }
            label="I accept the terms and conditions"
          />
          {validated && !termsAccepted && (
            <Typography color="error">You must accept the terms.</Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" color="primary" type="submit" fullWidth>
            Submit
          </Button>
        </Grid>
      </Grid>
      <Typography variant="h5">{showMessage}</Typography>
    </form>
  );
};

export default CompleteForm;
